// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__JZ3B3","author":"Table_author__3g0HH","authorImage":"Table_authorImage__12JdC","unreadRow":"Table_unreadRow__2RTGC"};